import React from "react";
import AuthorForm from "./AuthorForm";
import { SummaryCard } from "../../../components/SummaryCard";

const AddAuthor = () => {
    return (
        <div className="page-content">
            <SummaryCard>
                <AuthorForm mode="add" />
            </SummaryCard>
        </div>
    );
};

export default AddAuthor;
